import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Nav from '../../../Components/base/nav';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import RichTextEditor from '../../../Components/RichTextEditor'; // Ensure this import is correct
import ChooseImage from '../../../Components/Modal/ChooseImage';
import Sidebar from '../../../Components/base/sidebar';
import { Button } from 'react-bootstrap';
import { BsEye, BsTrash } from 'react-icons/bs';
import ActionBar from '../../../Components/Button/ActionBar';
import ContentForm from '../../../Components/Forms/ShowForm';
import SEOForm from '../../../Components/Forms/SEOForm';
import Delete from '../../../Components/Button/Delete';
import StoryDetails from '../../../Components/Forms/StoryDetails';
import VideoForm from '../../../Components/Forms/VideoForm';
import { toast } from 'sonner';

export default function ShortStory() {
  const location = useLocation();
  const id = location.state && location.state.id;
  const [url, setUrl] = useState('');
  const [sub_category, setSubCategory] = useState('');
  const [title, setTitle] = useState('');
  const [seo_title, setSeo_Title] = useState('');
  const [description, setDescription] = useState('');
  const [body, setBody] = useState('');
  const [sub_head, setSubHead] = useState('');
  const [item, setItem] = useState<any | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      fetchItem(id);
    }
  }, [id]);

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(e.target.value);
  };

  const handleSubCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setSubCategory(e.target.value);
  };

    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTitle(e.target.value); 
    };

    const handleSeoTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSeo_Title(e.target.value);
    };

    const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescription(e.target.value);
    };

    const handleBodyChange = (content: string) => {
        setBody(content);
    };

    const handleSubHeadChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSubHead(e.target.value);
    };
    const navigate = useNavigate();

    const fetchItem = async (id: number) => {
        try {
            const response = await axios.get(`https://cdn.pulp.ph/api/v1/pulpliveworld/videos/${id}`); // Fetch item based on ID
            const video = response.data.videos;
            if (video) {
                const { url, sub_category, title, body, seo_title, description, sub_head } = video;
                setItem(video);
                setSubCategory(sub_category);
                setUrl(url)
                setTitle(title);
                setBody(body);
                setSeo_Title(seo_title);
                setDescription(description);
                setSubHead(sub_head);
            }
        } catch (error) {
            console.error('Error fetching item:', error);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formData = new FormData();
        formData.append('url', url);
        formData.append('sub_category', sub_category);
        formData.append('title', title);
        formData.append('body', body);
        formData.append('seo_title', seo_title);
        formData.append('description', description);
        formData.append('sub_head', sub_head);
        
        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                // Handle the case where authToken is not available
                alert('Authentication token not found!');
                setIsSubmitting(false);
                return;
            }

            await axios.post(`https://cdn.pulp.ph/api/v1/pulpliveworld/video/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                }
            });

            toast.success(<p className="text-[16px]">Content was submitted successfully!</p>, {
                duration: 1500,
            });
            
            setTimeout(() => {
                navigate('/view/post/video');
            }, 1600);
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            alert(`There was an error submitting the form!, ${error}`);
            // Handle error (e.g., show an error message)
        } finally {
            setTimeout(() => {
                setIsSubmitting(false);
            }, 3000);
        }
    };


    const handleSaveDraft = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSaved(true);

        const formData = new FormData();
        formData.append('url', url);
        formData.append('sub_category', sub_category);
        formData.append('title', title);
        formData.append('body', body);
        formData.append('seo_title', seo_title);
        formData.append('description', description);
        formData.append('sub_head', sub_head);

        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                // Handle the case where authToken is not available
                alert('Authentication token not found!');
                setIsSubmitting(false);
                return;
            }

            await axios.post(`https://cdn.pulp.ph/api/v1/pulpliveworld/video/save/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                }
            });
            alert('Draft Saved Successfully !!'); // Handle success (e.g., show a success message or redirect)
            navigate('/view/post/video');
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            alert(`There was an error submitting the form!, ${error}`);
            // Handle error (e.g., show an error message)
        } finally {
            setTimeout(() => {
                setIsSaved(false);
            }, 3000);
        }
    };

    const handleDelete = async () => {
        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                alert('Authentication token not found!');
                return;
            }

            const confirmDelete = window.confirm('Are you sure you want to delete this content?');
            if (!confirmDelete) {
                return; // If user cancels, do nothing
            }

            if (id) {
                await axios.delete(`https://cdn.pulp.ph/api/v1/pulpliveworld/video/${id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    }
                })
            };
            alert('Content Deleted Successfully !!');
            navigate('/view/post/video');
        } catch (error) {
            console.error('There was an error deleting the content!', error);
            alert(`There was an error deleting the content!, ${error}`);
        }
    };

    useEffect(() => {
        const storedRole = localStorage.getItem('role');
        setRole(storedRole);
    }, []);

    const handleViewShortstory = () => {
        window.open(`https://pulpmagazine.com/article/video/${id}`, '_blank');
    };

    return (
      <>
        <div className="w-full p-5">
            <div className="flex justify-between items-center mb-4">
              <h1 className="GraphikSemibold text-[20px] font-semibold">Edit Video</h1>
              <ActionBar
                  role={role}
                  onSubmit={handleSubmit}
                  onView={handleViewShortstory}
                  isSubmitting={isSubmitting}
                  isSaved={isSubmitting}
              />
            </div>

            <div className="py-5 px-4 rounded bg-white">
              <VideoForm
                  url={url}
                  sub_category={sub_category}
                  title={title}
                  sub_head={sub_head}
                  body={body}
                  onSubCategoryChange={handleSubCategoryChange}
                  onUrlChange={handleUrlChange}
                  onTitleChange={handleTitleChange}
                  onSubHeadChange={handleSubHeadChange}
                  onBodyChange={handleBodyChange}
              />

              {(role === 'Magazine' || role === 'IT') && (
              <SEOForm
                seo_title={seo_title}
                description={description}
                onSeoTitleChange={handleSeoTitleChange}
                onDescriptionChange={handleDescriptionChange}
              />)}
              
              <div className='w-full border-1 border-black rounded mb-5'> </div>
              <StoryDetails/>
              <Delete
              onDelete={handleDelete}
              />
            </div>
        </div>
      </>
    );
}
